import { Box, Button, Divider, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { formatValue } from 'react-currency-input-field';
import * as dateFNS from 'date-fns';

const formatPrice = (price) => {
  return formatValue({
    value: price,
    groupSeparator: '.',
    decimalSeparator: ',',
    prefix: 'R$'
  });
}

function Section({title, children}) {
  return (
    <>
      <Typography variant="h6">{title}</Typography>
      <Grid item container wrap="wrap" spacing={3}>
        {children}
      </Grid>
    </>
  );
}

function SectionItem({ label, children }) {
  return (
    <Grid item xs={6}>
      <Typography variant="caption" component="p">{label}</Typography>
      <Typography variant="subtitle1">{children}</Typography>
    </Grid>
  );
}

export default function SummaryStep({ customer, address, payment, onSubmit, boleto }) {
  const handleGenerateBoleto = ({ openLast = false }) => {
    onSubmit({ customer, address, payment, openLast });
  }

  return (
   <Box marginTop={3}>
    <Grid container spacing={5}>
      <Section title="Dados do Comprador">
        {!customer?.isCompany && <SectionItem label="ID">{customer?.user?.id}</SectionItem>}
        <SectionItem label="Nome">{customer?.isCompany ? customer?.companyName : customer?.user?.name}</SectionItem>
        <SectionItem label="Documento">{customer?.document}</SectionItem>
        {<SectionItem label="Email">{customer?.isCompany ? customer?.email : customer?.user?.email}</SectionItem>}
      </Section>
      <Section title="Endereço do Comprador">
        <SectionItem label="CEP">{address?.cep}</SectionItem>
        <SectionItem label="Rua">{address?.street}</SectionItem>
        <SectionItem label="Bairro">{address?.district}</SectionItem>
        <SectionItem label="Número">{address?.num}</SectionItem>
        <SectionItem label="Estado">{address?.uf}</SectionItem>
        <SectionItem label="Cidade">{address?.city}</SectionItem>
        <SectionItem label="Complement">{address?.complement}</SectionItem>
      </Section>
      <Section title="Dados do Pagamento">
        {!payment?.product?.isCustomProduct && <SectionItem label="ID">{payment?.product?.id}</SectionItem>}
        <SectionItem label="Produto">{payment?.product?.name}</SectionItem>
        <SectionItem label="Preço">{formatPrice(payment?.price)}</SectionItem>
        {payment?.needInstallments && (
          <>
            <SectionItem label="Parcelas">{payment?.installments}</SectionItem>
            <SectionItem label="Valor parcela">{formatPrice(payment?.installmentPrice)}</SectionItem>
          </>
        )}
        {payment?.dueAt && <SectionItem label="Vencimento">{dateFNS.format(new Date(payment?.dueAt), 'dd/MM/yyyy')}</SectionItem>}
        <SectionItem label="Instruções">{payment?.instructions}</SectionItem>
        <SectionItem label="Observação">{payment?.notes}</SectionItem>
      </Section>
      <Grid item container spacing={2} justifyContent="flex-end">
        {!!boleto && (
          <Grid item>
            <Button variant="outlined" color="secondary" onClick={() => handleGenerateBoleto({ openLast: true })}>Abrir último boleto</Button>
          </Grid>
        )}
        <Grid item>
          <Button variant="contained" color="primary" onClick={handleGenerateBoleto}>Gerar Boleto</Button>
        </Grid>
      </Grid>
    </Grid>
   </Box>
  );
}